{
  "hero": {
    "ownerName": "Christian Fey",
    "restaurantHistory": "Am Tibarg Süd neben dem Ponzu hat Christian Fey die Chance ergriffen, sein eigenes Lokal zu eröffnen. Auch wenn es ein neues Konzept und ein neuer Name ist – erwartet euch weiterhin ausgezeichnetes Essen und leckere Getränke.",
    "philosophy": "Im Fey geht es nicht nur darum, gemütlich zusammenzukommen und zu essen, sondern auch darum, ein willkommener Gast zu sein. Unsere mediterran inspirierte Küche lädt dazu ein, den Moment zu genießen und sich wie zu Hause zu fühlen.",
    "address": "Fey am Tibarg, Tibarg 16, 22459 Hamburg",
    "cuisineType": "Mediterran inspiriert"
  },
  "wine": {
    "description": "Weinbau ist unsere Tradition – Marcus stammt aus einer Weinbaufamilie. Bereits in der 7. Generation fühlen wir uns dem Mosel-Riesling verpflichtet und wir sind fest davon überzeugt: \"Das schmeckt Ihr\" und macht eine Riesenfreude. Die Vielfalt der Schieferböden und das Mikroklima der Weinberge zeigen sich in unseren Weinen eindrucksvoll. Durch den Rebsorten-Spiegel entfalten sich sämtliche Spielarten des Moselweines. Alle Weine sind im modernen Stil ausgebaut und daher durch das Reduzieren der Säure im Geschmacksbild sehr beeindruckend. Weine & Spirituosen von der Mosel mit dem Bestreben, diesen \"Schatz der Natur\" zu bewahren.",
    "externalLink": "https://schluerfgold.de/"
  },
  "contact": {
    "phone": "040 23994340",
    "email": "fey-am-tibarg@gmx.de",
    "openingHours": [
      { "day": "Montag", "hours": "12:00 – 22:00 Uhr" },
      { "day": "Dienstag", "hours": "Geschlossen" },
      { "day": "Mittwoch", "hours": "Geschlossen" },
      { "day": "Donnerstag", "hours": "12:00 – 22:00 Uhr" },
      { "day": "Freitag", "hours": "12:00 – 22:00 Uhr" },
      { "day": "Samstag", "hours": "12:00 – 22:00 Uhr" },
      { "day": "Sonntag", "hours": "12:00 – 22:00 Uhr" }
    ]
  },
  "social": {
    "instagram": "https://www.instagram.com/feyamtibarg/",
    "facebook": "https://www.facebook.com/profile.php?id=61589056978070"
  },
  "impressum": {
    "ownerName": "Christian Fey",
    "address": "Fey am Tibarg, Tibarg 16, 22459 Hamburg",
    "phone": "040 23994340",
    "email": "fey-am-tibarg@gmx.de"
  }
}
